<template>
  <div id="app">
    <h1>VueJS loader-spinner</h1>
    <loader :active="loaderActive" message="Please wait 5 seconds" />

    <div v-show="employees.length">
      <button @click="refreshData">Refresh data</button>

      <table>
        <thead>
          <tr>
            <th>index</th>
            <th>age</th>
            <th>eyeColor</th>
            <th>name</th>
            <th>gender</th>
            <th>company</th>
            <th>email</th>
            <th>phone</th>
            <th>salary</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in employees" :key="row.index">
            <td>{{row.index}}</td>
            <td>{{row.age}}</td>
            <td>{{row.eyeColor}}</td>
            <td>{{row.name}}</td>
            <td>{{row.gender}}</td>
            <td>{{row.company}}</td>
            <td>{{row.email}}</td>
            <td>{{row.phone}}</td>
            <td><input type="number" v-model="row.salary"></td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
import Loader from './components/Loader.vue'
import { employeesJson } from './mock-data/employees';
import loaderMixin from './mixins/loader';

export default {
  name: 'App',
  components: {
    Loader
  },
  mixins: [loaderMixin],
  data: () => {
    return {
      employees: []
    }
  },
  methods: {
    loadData () {
      this.showLoader();
      setTimeout(() => {
        this.employees = JSON.parse(employeesJson);
        this.hideLoader();
      }, 5000);
    },
    refreshData () {
      this.employees = [];
      this.loadData();
    }
  },
  mounted () {
    this.loadData();
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}

table {
  width: 100%;
  max-width: 1200px;
  margin: 20px auto;
}

button {
    padding: 10px;
    background: #07ab85;
    color: #fff;
    font-weight: bold;
    border: none;
    text-transform: uppercase;
    border-radius: 5px;
}

</style>
